export const formatQuantity = quantity => (quantity >= 999 ? "999+" : quantity);

export const collectNonEmptyQtys = $$form => {
  const formItems = {};

  $$form
    .serializeArray()
    .filter(el => el.name)
    .forEach(el => {
      if (!el.name.match(/variants\[\d+\]\[quantity\]/)) {
        formItems[el.name] = el.value;
      } else if (el.value) {
        formItems[el.name] = parseInt(el.value, 10);
      }
    });
  return formItems;
};

export default $form => {
  const formItemsQty = {};
  $form
    .serializeArray()
    .filter(el => el.name && el.value && el.name.match(/variants\[\d+\]\[quantity\]/))
    .forEach(el => {
      const variantId = parseInt(el.name.match(/variants\[(\d+)\]/)[1], 10);
      formItemsQty[variantId] = parseInt(el.value, 10);
    });
  return formItemsQty;
};
